import * as swcHelpers from '@swc/helpers';
import { optionalKey } from '@grandvisionhq/utils';
import { unwrapResponse } from '../response.js';
import { acceptJson, postJson, authHeader } from '../shared.js';

function changeAddress(apiUrl, accessToken, customerId, request) {
    return _changeAddress.apply(this, arguments);
}
function _changeAddress() {
    _changeAddress = swcHelpers.asyncToGenerator(function*(apiUrl, accessToken, customerId, request) {
        var _externalId;
        return unwrapResponse((yield fetch(`${apiUrl}/customers/customer/${encodeURIComponent(customerId)}/addresses`, {
            method: 'PUT',
            headers: swcHelpers.objectSpread({}, acceptJson, postJson, authHeader(accessToken)),
            body: JSON.stringify(swcHelpers.objectSpread({}, request.fields, {
                addressTypes: request.addressTypes
            }, optionalKey('externalId', String((_externalId = request.externalId) !== null && _externalId !== void 0 ? _externalId : ''))))
        })));
    });
    return _changeAddress.apply(this, arguments);
}

export { changeAddress };
//# sourceMappingURL=change-address.js.map
